module.exports = __webpack_public_path__ + "assets/2025-03-12-02.d6c75b55.pdf";